import { getResourcefulApiUrl } from './common';
import { getMethodMutableOverride, getMutableMethodMiddleware } from './internal';
export function createApiFetchClient(apiConfig) {
  const methodNames = Object.keys(apiConfig);
  const fetchers = methodNames.reduce((acc, methodName) => ({
    ...acc,
    [methodName]: createApiFetchFn({
      methodConfig: apiConfig[methodName]
    })
  }), {});
  return {
    fetch: fetchers
  };
}
export function createApiFetchFn(_ref) {
  let {
    methodConfig
  } = _ref;
  const service = methodConfig.service;
  const queryFn = methodConfig.queryFn;
  const httpOrQueryFn = queryFn != null ? queryFn : _createHttpRequest({
    methodConfig
  });
  return async _ref2 => {
    var _methodConfig$request, _service$requestTrans, _methodFnMiddleware, _methodConfig$respons;
    let {
      httpClient,
      request
    } = _ref2;
    let body = (_methodConfig$request = methodConfig.requestTransform == null ? void 0 : methodConfig.requestTransform(request)) != null ? _methodConfig$request : request;
    body = (_service$requestTrans = service.requestTransform == null ? void 0 : service.requestTransform(body)) != null ? _service$requestTrans : body;
    const methodFnMiddleware = getMutableMethodMiddleware(methodConfig);
    const fetchFn = (_methodFnMiddleware = methodFnMiddleware == null ? void 0 : methodFnMiddleware(httpOrQueryFn)) != null ? _methodFnMiddleware : httpOrQueryFn;
    let data;
    try {
      data = await fetchFn({
        httpClient,
        request: body
      });
    } catch (err) {
      var _methodConfig$onError;
      const errData = await ((_methodConfig$onError = methodConfig.onError == null ? void 0 : methodConfig.onError(err, request)) != null ? _methodConfig$onError : service.onError == null ? void 0 : service.onError(err, methodConfig.name, request));
      if (errData) {
        data = errData;
      } else {
        throw err;
      }
    }
    let transformedData = service.responseTransform ? service.responseTransform(data, request) : data;
    transformedData = (_methodConfig$respons = methodConfig.responseTransform == null ? void 0 : methodConfig.responseTransform(transformedData, request)) != null ? _methodConfig$respons : transformedData;
    const override = getMethodMutableOverride(methodConfig);
    return {
      ...transformedData,
      ...override
    };
  };
}
function _createHttpRequest(_ref3) {
  let {
    methodConfig
  } = _ref3;
  return async _ref4 => {
    var _ref5, _methodConfig$httpMet;
    let {
      httpClient,
      request
    } = _ref4;
    const service = methodConfig.service;
    const url = getResourcefulApiUrl(methodConfig, request);
    const httpMethod = (_ref5 = (_methodConfig$httpMet = methodConfig.httpMethod) != null ? _methodConfig$httpMet : service.defaultHttpMethod) != null ? _ref5 : 'post';
    const {
      data
    } = await httpClient.request({
      url,
      method: httpMethod,
      data: httpMethod.toLowerCase() !== 'get' ? request : undefined,
      params: httpMethod.toLowerCase() === 'get' ? request : undefined,
      timeout: 30000,
      // TODO: Business Manager httpClient prevents adding custom paramsSerializer (they use qs behind the scenes already), when they allow custom serializer we can uncomment this
      // paramsSerializer:
      //   httpMethod === 'get' ? qs.stringify: undefined,
      ...service.requestOptions
    });
    return data;
  };
}
//# sourceMappingURL=createApiFetchClient.js.map